module.exports = __webpack_public_path__ + "static/media/SWSCRC6-8.9f45742f.mp3";